import React, { useMemo } from 'react'
import { StyleSheet, Text, View, ViewStyle } from 'react-native'

import { ChatKind } from '@/models/api-store'
import { fontFamily } from '../../../../../../theme'
import { palette } from '../../../../../../theme/palette'

type ChatMessageContentProps = {
  name: string
  message: string
  type: keyof typeof ChatKind
  timestamp: string
}

const ChatMessageContent = ({ name, message, type, timestamp }: ChatMessageContentProps) => {
  const isInternal = type === ChatKind.dealer || type === ChatKind.engine
  const messageStyle: ViewStyle = isInternal
    ? type === ChatKind.dealer
      ? styles.dealerMessageContainer
      : styles.engineMessageContainer
    : styles.userMessageContainer

  return (
    <View style={styles.container}>
      {!isInternal && <Text style={styles.userName}>{name}</Text>}
      <View style={messageStyle}>
        <Text style={styles.messageText}>{message}</Text>
      </View>
      <Text style={styles.timestamp}>{timestamp}</Text>
    </View>
  )
}

export default ChatMessageContent

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'flex-start'
  },
  userName: {
    fontSize: 14,
    lineHeight: 16,
    fontFamily: fontFamily.GTAmericaExtended,
    fontWeight: '500'
  },
  userMessageContainer: {
    borderColor: 'lightgray',
    borderWidth: 1,
    borderRadius: 4,
    padding: 16,
    marginTop: 8
  },
  messageText: {
    fontSize: 16,
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  dealerMessageContainer: {
    backgroundColor: palette.timberwolf,
    borderRadius: 20,
    padding: 16,
    marginTop: 9
  },
  engineMessageContainer: {
    backgroundColor: palette.lightGreen,
    borderRadius: 10,
    padding: 12,
    marginTop: 9
  },
  timestamp: {
    fontSize: 10,
    fontFamily: fontFamily.FeatureDeckLight,
    marginTop: 8,
    paddingLeft: 4
  }
})
